import { enAU } from "../../../../date-fns/locale/en-AU.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    enAU
  }
};